import { practiceSidebar } from 'lib/constants/sidebar/practiceSidebar';

const buildPortalPermissionMap = () => {
  const map = {};
  const sidebar = practiceSidebar({ userState: null });

  Object.values(sidebar).forEach((item) => {
    if (item.path && item.permission) {
      map[item.path] = item.permission;
    }

    if (item.children) {
      item.children.forEach((child) => {
        if (child.children) {
          // section wrapper { title, children: [...navItems] }
          child.children.forEach((navItem) => {
            if (navItem.path && navItem.permission) {
              map[navItem.path] = navItem.permission;
            }
          });
        } else if (child.path && child.permission) {
          // flat nav item directly in children
          map[child.path] = child.permission;
        }
      });
    }
  });

  return map;
};

export const PORTAL_PERMISSION_MAP = buildPortalPermissionMap();

// Returns the permission key required for the given /portal/... pathname,
// using the longest matching sidebar path as the authoritative rule.
export const getPortalRoutePermission = (pathname) => {
  const relativePath = pathname.replace(/^\/portal\//, '');

  let bestMatch = null;
  let bestMatchLength = 0;

  Object.entries(PORTAL_PERMISSION_MAP).forEach(([path, permission]) => {
    if (
      (relativePath === path || relativePath.startsWith(`${path}/`)) &&
      path.length > bestMatchLength
    ) {
      bestMatch = permission;
      bestMatchLength = path.length;
    }
  });

  return bestMatch;
};
